<span #trigger *ngIf="help.tooltips?.length">
   <button mat-icon-button *ngIf="breakpoints.large" (mouseenter)="toggle( trigger )" (mouseleave)="tooltipRef.detach()">
      <mat-icon>help</mat-icon>
   </button>

   <button mat-icon-button *ngIf="!breakpoints.large" (mouseleave)="tooltipRef.detach()" (click)="toggle( trigger )">
      <mat-icon>help</mat-icon>
   </button>
</span>
